import React, { useMemo } from 'react';
import Markdown from 'markdown-to-jsx';

const MyLink = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children[0] || href}
  </a>
);

const MyImage = ({ alt, src }) => {
  if (!src) {
    return alt || null;
  }
  return (
    <a href={src} target="_blank" rel="noopener noreferrer">
      <img alt={alt} src={src} />
    </a>
  );
};

const markdownOptions = {
  disableParsingRawHTML: true,
  slugify: () => null,
  overrides: {
    a: MyLink,
    img: MyImage,
  },
};

const MarkdownLinebreakBetweenText = /([^\s].*?)\r?\n(?=\s*(?![-*] )\S)/g;

// this function adds markdown 2-spaces at the end of text to parse a linebreak
// but it avoids this insice a code block
const smartLineBreaks = (text) => {
  const codeBlockRegex = /```[\s\S]*?```/g;

  const segments = [];
  let lastIndex = 0;

  const matches = text.matchAll(codeBlockRegex);
  for (const match of matches) {
    const { index } = match;

    if (index > lastIndex) {
      const before = text.slice(lastIndex, index);
      segments.push({ type: 'text', content: before });
    }

    segments.push({ type: 'code', content: match[0] });

    lastIndex = index + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', content: text.slice(lastIndex) });
  }

  const processed = segments.map((seg) => {
    if (seg.type === 'text') {
      return seg.content.replace(MarkdownLinebreakBetweenText, '$1  \n');
    } else {
      return seg.content; // leave code block untouched
    }
  });

  return processed.join('');
};

const MessageParser = ({ children }) => {
  const parsedText = useMemo(() => smartLineBreaks(children), [children]);
  return <Markdown options={markdownOptions}>{parsedText}</Markdown>;
};

export default MessageParser;
